declare namespace $ {

	type $mol_view__sub_shm_hitalama_map_presence_cursor_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_map_presence_cursor extends $mol_view {
		top_px( ): string
		left_px( ): string
		Icon( ): $mol_icon_cursor_default
		name( ): string
		Name( ): $mol_view
		pos( ): readonly(number)[]
		style( ): ({ 
			'top': ReturnType< $shm_hitalama_map_presence_cursor['top_px'] >,
			'left': ReturnType< $shm_hitalama_map_presence_cursor['left_px'] >,
		})  & ReturnType< $mol_view['style'] >
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=cursor.view.tree.d.ts.map